// Tutoriales: el recorrido de bienvenida y los cortos del menú (ver
// components/tutorial/tours.js). <b>…</b> = negrita dorada.
const en = {
  'tutorial.counter': 'Step {n} of {total}',
  'tutorial.next': 'Next',
  'tutorial.back': 'Back',
  'tutorial.finish': 'Done',
  'tutorial.letsGo': "Let's go",
  'tutorial.skipAll': 'Skip tutorial',
  'tutorial.skipStep': 'Skip this step',
  'tutorial.yourTurn': 'Your turn: do it to continue',
  'tutorial.notVisible': "It's not on screen right now. Continue whenever you like.",
  'tutorial.minutes': '~{n} min',

  'tutorial.setup.title': 'Nice to meet you, {name}',
  'tutorial.setup.sub': 'Three quick things so DragonAudio fits you. Then a one-minute tour.',
  'tutorial.setup.save': 'Save and start',
  'tutorial.setup.later': 'Not now',

  'tutorial.menu.item': 'Tutorials',
  'tutorial.menu.itemTitle': 'Short guided tours of the app',
  'tutorial.menu.title': 'Tutorials',
  'tutorial.menu.sub': 'Pick one and I will walk you through it, step by step.',

  'tutorial.tour.welcome.title': 'First steps',
  'tutorial.tour.welcome.desc': 'The whole app in one minute: sound, rack, volume and Fuxi.',
  'tutorial.tour.fuxi.title': 'Talk to Fuxi',
  'tutorial.tour.fuxi.desc': 'Ask the AI for the sound you want, in your own words.',
  'tutorial.tour.effects.title': 'Add effects',
  'tutorial.tour.effects.desc': 'Put effects in the rack, move their knobs, solo and mute.',
  'tutorial.tour.save.title': 'Save your sound',
  'tutorial.tour.save.desc': 'Ready-made templates, save your own and compare with Bypass.',
  'tutorial.tour.device.title': 'Tune your speakers',
  'tutorial.tour.device.desc': 'The hearing test and how to use its device profile.',
  'tutorial.tour.look.title': 'Theme, language and mode',
  'tutorial.tour.look.desc': 'Light/dark, English/Spanish, Lite/Dragon and the visualizer.',

  'tutorial.s.welcome.title': 'Welcome to DragonAudio 龙',
  'tutorial.s.welcome.body': 'In one minute you will know how to make anything sound better: pick a sound, add effects and, if you prefer, just <b>ask the AI</b>. You can skip this whenever you want.',
  'tutorial.s.sources.title': 'Where does the sound come from?',
  'tutorial.s.sources.body': '<b>Tab</b>: YouTube, Spotify or any page. <b>Mic</b>: your voice. <b>File</b>: your songs. <b>Just enter</b>: look around without sound.',
  'tutorial.s.sourcesMobile.title': 'Where does the sound come from?',
  'tutorial.s.sourcesMobile.body': '<b>File</b>: your songs, in the Player card. <b>Mic</b>: your voice. <b>Just enter</b>: look around without sound.',
  'tutorial.s.start.title': 'Turn it on',
  'tutorial.s.start.body': 'Choose a source and press the <b>power button</b>. Just exploring? Pick <b>Just enter</b>: it asks for no permissions.',
  'tutorial.s.toRack.title': 'Go to the rack',
  'tutorial.s.toRack.body': 'Press this button to flip the card to the <b>effects rack</b>.',
  'tutorial.s.rack.title': 'Your effects rack',
  'tutorial.s.rack.body': 'Six slots, like real studio gear. The sound goes through them <b>from 1 to 6</b>. Empty slot = sound passes untouched.',
  'tutorial.s.addFx.title': 'Add an effect',
  'tutorial.s.addFx.body': 'This is the catalog. Press <b>＋</b> on any effect (or drag it to a slot).',
  'tutorial.s.addFxPhone.title': 'Add an effect',
  'tutorial.s.addFxPhone.body': 'Tap an <b>empty slot</b> and choose an effect from the list.',
  'tutorial.s.card.title': 'Play with it',
  'tutorial.s.card.body': 'Turn the knobs and listen. <b>S</b> = hear only this one, <b>M</b> = mute it, <b>✕</b> = remove it. Drag <b>⣿</b> to reorder.',
  'tutorial.s.soloMute.title': 'Solo, mute and order',
  'tutorial.s.soloMute.body': 'Each card has <b>S</b> (solo: only it sounds) and <b>M</b> (mute). The green light tells you if it is working. Drag the <b>⣿</b> handle to change the order.',
  'tutorial.s.toolbar.title': 'Templates and saving',
  'tutorial.s.toolbar.body': 'Pick a <b>ready-made template</b>, save yours with <b>Save</b>, and press <b>BYPASS</b> to compare with and without effects.',
  'tutorial.s.master.title': 'Final volume',
  'tutorial.s.master.body': 'The dragon knob is the <b>master volume</b>. Above 100% it amplifies: careful with your ears.',
  'tutorial.s.toChat.title': 'Meet Fuxi, your AI',
  'tutorial.s.toChat.body': 'Don\'t want to touch knobs? Press this button to talk to <b>Fuxi</b>.',
  'tutorial.s.fuxiAsk.title': 'Ask in your own words',
  'tutorial.s.fuxiAsk.body': 'Write things like <b>"more bass"</b> or <b>"clearer voice"</b>. Fuxi moves the rack for you, and <b>↶</b> undoes it.',
  'tutorial.s.fuxiLog.title': 'Your conversation',
  'tutorial.s.fuxiLog.body': 'Fuxi\'s answers appear here, with ready-made <b>templates</b> you can press.',
  'tutorial.s.fuxiChips.title': 'Quick ideas',
  'tutorial.s.fuxiChips.body': 'No idea what to ask? Press a <b>suggestion</b> and Fuxi does it.',
  'tutorial.s.fuxiUndo.title': 'Undo',
  'tutorial.s.fuxiUndo.body': 'Didn\'t like the change? <b>↶</b> brings back how it was before.',
  'tutorial.s.fuxiBack.title': 'Back to the rack',
  'tutorial.s.fuxiBack.body': 'From here you return to the rack to see (and touch) what Fuxi changed.',
  'tutorial.s.orb.title': 'The 龙 orb',
  'tutorial.s.orb.body': 'From anywhere on the page, this orb flips between <b>Fuxi</b> and the <b>rack</b>.',
  'tutorial.s.menu.title': 'More tutorials',
  'tutorial.s.menu.body': 'Open your menu here and choose <b>Tutorials</b> to repeat this or learn something else.',
  'tutorial.s.finish.title': 'All set!',
  'tutorial.s.finish.body': 'Now make it sound your way. If you get lost, the <b>Tutorials</b> are always in your menu.',
  'tutorial.s.presets.title': 'Templates and your settings',
  'tutorial.s.presets.body': 'Open this list: <b>DragonAudio templates</b> (clear voice, more bass, movies…) and below, <b>your saved settings</b>. ◀ ▶ switch between them.',
  'tutorial.s.saveBtn.title': 'Save',
  'tutorial.s.saveBtn.body': 'Like how it sounds? Press <b>Save</b>, give it a name and it stays in your account.',
  'tutorial.s.bypass.title': 'Compare with Bypass',
  'tutorial.s.bypass.body': '<b>BYPASS</b> turns off every effect at once (same volume) so you can hear the difference.',
  'tutorial.s.recalibrate.title': 'The hearing test',
  'tutorial.s.recalibrate.body': 'A short test of your speakers or headphones. DragonAudio corrects what they lack.',
  'tutorial.s.device.title': 'Your device',
  'tutorial.s.device.body': 'Each test is saved as a <b>device profile</b>. Choose it here when you change headphones or speakers.',
  'tutorial.s.theme.title': 'Light or dark',
  'tutorial.s.theme.body': 'This switch changes between <b>light</b> and <b>dark</b> mode.',
  'tutorial.s.lang.title': 'Language',
  'tutorial.s.lang.body': 'Switch between <b>English</b> and <b>Spanish</b> without losing what is playing.',
  'tutorial.s.mode.title': 'Lite or Dragon',
  'tutorial.s.mode.body': '<b>Dragon</b> has animated background and visualizer. <b>Lite</b> turns off every decoration and leaves the CPU to the sound: ideal for modest computers.',
  'tutorial.s.spectrum.title': 'The visualizer',
  'tutorial.s.spectrum.body': 'See your sound live: bass on the left, treble on the right. Change the style or <b>freeze</b> it to look closely.',
};

const es = {
  'tutorial.counter': 'Paso {n} de {total}',
  'tutorial.next': 'Siguiente',
  'tutorial.back': 'Atrás',
  'tutorial.finish': 'Listo',
  'tutorial.letsGo': 'Empezar',
  'tutorial.skipAll': 'Saltar tutorial',
  'tutorial.skipStep': 'Saltar paso',
  'tutorial.yourTurn': 'Te toca: hazlo para seguir',
  'tutorial.notVisible': 'Ahora no está en pantalla. Sigue cuando quieras.',
  'tutorial.minutes': '~{n} min',

  'tutorial.setup.title': 'Mucho gusto, {name}',
  'tutorial.setup.sub': 'Tres cosas rápidas para que DragonAudio se ajuste a ti. Luego, un recorrido de un minuto.',
  'tutorial.setup.save': 'Guardar y empezar',
  'tutorial.setup.later': 'Ahora no',

  'tutorial.menu.item': 'Tutoriales',
  'tutorial.menu.itemTitle': 'Recorridos cortos y guiados por la app',
  'tutorial.menu.title': 'Tutoriales',
  'tutorial.menu.sub': 'Elige uno y te lo enseño paso a paso.',

  'tutorial.tour.welcome.title': 'Primeros pasos',
  'tutorial.tour.welcome.desc': 'Toda la app en un minuto: sonido, rack, volumen y Fuxi.',
  'tutorial.tour.fuxi.title': 'Hablar con Fuxi',
  'tutorial.tour.fuxi.desc': 'Pídele a la IA el sonido que quieres, con tus palabras.',
  'tutorial.tour.effects.title': 'Añadir efectos',
  'tutorial.tour.effects.desc': 'Pon efectos en el rack, mueve sus perillas, solo y mute.',
  'tutorial.tour.save.title': 'Guardar tu sonido',
  'tutorial.tour.save.desc': 'Plantillas listas, guarda las tuyas y compara con Bypass.',
  'tutorial.tour.device.title': 'Ajustar tus parlantes',
  'tutorial.tour.device.desc': 'El test de audición y cómo usar su perfil de dispositivo.',
  'tutorial.tour.look.title': 'Tema, idioma y modo',
  'tutorial.tour.look.desc': 'Claro/oscuro, inglés/español, Ligero/Dragón y el visualizador.',

  'tutorial.s.welcome.title': 'Bienvenido a DragonAudio 龙',
  'tutorial.s.welcome.body': 'En un minuto sabrás hacer que cualquier cosa suene mejor: elige un sonido, añade efectos o, si prefieres, <b>pídeselo a la IA</b>. Puedes saltarlo cuando quieras.',
  'tutorial.s.sources.title': '¿De dónde viene el sonido?',
  'tutorial.s.sources.body': '<b>Pestaña</b>: YouTube, Spotify o cualquier página. <b>Micrófono</b>: tu voz. <b>Archivo</b>: tus canciones. <b>Solo entrar</b>: mirar sin sonido.',
  'tutorial.s.sourcesMobile.title': '¿De dónde viene el sonido?',
  'tutorial.s.sourcesMobile.body': '<b>Archivo</b>: tus canciones, en la tarjeta Reproductor. <b>Micrófono</b>: tu voz. <b>Solo entrar</b>: mirar sin sonido.',
  'tutorial.s.start.title': 'Enciéndelo',
  'tutorial.s.start.body': 'Elige una fuente y pulsa el <b>botón de encender</b>. ¿Solo quieres mirar? Elige <b>Solo entrar</b>: no pide permisos.',
  'tutorial.s.toRack.title': 'Ve al rack',
  'tutorial.s.toRack.body': 'Pulsa este botón para girar la tarjeta hacia el <b>rack de efectos</b>.',
  'tutorial.s.rack.title': 'Tu rack de efectos',
  'tutorial.s.rack.body': 'Seis huecos, como los aparatos de un estudio. El sonido pasa por ellos <b>del 1 al 6</b>. Hueco vacío = el sonido pasa tal cual.',
  'tutorial.s.addFx.title': 'Añade un efecto',
  'tutorial.s.addFx.body': 'Este es el catálogo. Pulsa <b>＋</b> en cualquier efecto (o arrástralo a un hueco).',
  'tutorial.s.addFxPhone.title': 'Añade un efecto',
  'tutorial.s.addFxPhone.body': 'Toca un <b>hueco vacío</b> y elige un efecto de la lista.',
  'tutorial.s.card.title': 'Juega con él',
  'tutorial.s.card.body': 'Gira las perillas y escucha. <b>S</b> = oír solo este, <b>M</b> = silenciarlo, <b>✕</b> = quitarlo. Arrastra <b>⣿</b> para cambiar el orden.',
  'tutorial.s.soloMute.title': 'Solo, mute y orden',
  'tutorial.s.soloMute.body': 'Cada tarjeta tiene <b>S</b> (solo: suena solo ella) y <b>M</b> (silenciar). La luz verde te dice si está trabajando. Arrastra el asa <b>⣿</b> para cambiar el orden.',
  'tutorial.s.toolbar.title': 'Plantillas y guardar',
  'tutorial.s.toolbar.body': 'Elige una <b>plantilla lista</b>, guarda la tuya con <b>Guardar</b> y pulsa <b>BYPASS</b> para comparar con y sin efectos.',
  'tutorial.s.master.title': 'Volumen final',
  'tutorial.s.master.body': 'La perilla del dragón es el <b>volumen master</b>. Por encima de 100 % amplifica: cuida tus oídos.',
  'tutorial.s.toChat.title': 'Conoce a Fuxi, tu IA',
  'tutorial.s.toChat.body': '¿No quieres tocar perillas? Pulsa este botón para hablar con <b>Fuxi</b>.',
  'tutorial.s.fuxiAsk.title': 'Pide con tus palabras',
  'tutorial.s.fuxiAsk.body': 'Escribe cosas como <b>"más graves"</b> o <b>"voz más clara"</b>. Fuxi mueve el rack por ti, y <b>↶</b> lo deshace.',
  'tutorial.s.fuxiLog.title': 'Tu conversación',
  'tutorial.s.fuxiLog.body': 'Aquí salen las respuestas de Fuxi, con <b>plantillas</b> listas para pulsar.',
  'tutorial.s.fuxiChips.title': 'Ideas rápidas',
  'tutorial.s.fuxiChips.body': '¿No sabes qué pedir? Pulsa una <b>sugerencia</b> y Fuxi la hace.',
  'tutorial.s.fuxiUndo.title': 'Deshacer',
  'tutorial.s.fuxiUndo.body': '¿No te gustó el cambio? <b>↶</b> vuelve a como estaba antes.',
  'tutorial.s.fuxiBack.title': 'Volver al rack',
  'tutorial.s.fuxiBack.body': 'Desde aquí vuelves al rack para ver (y tocar) lo que cambió Fuxi.',
  'tutorial.s.orb.title': 'El orbe 龙',
  'tutorial.s.orb.body': 'Desde cualquier parte de la página, este orbe gira entre <b>Fuxi</b> y el <b>rack</b>.',
  'tutorial.s.menu.title': 'Más tutoriales',
  'tutorial.s.menu.body': 'Abre tu menú aquí y elige <b>Tutoriales</b> para repetir este o aprender otra cosa.',
  'tutorial.s.finish.title': '¡Listo!',
  'tutorial.s.finish.body': 'Ahora hazlo sonar a tu gusto. Si te pierdes, los <b>Tutoriales</b> siempre están en tu menú.',
  'tutorial.s.presets.title': 'Plantillas y tus ajustes',
  'tutorial.s.presets.body': 'Abre esta lista: <b>plantillas DragonAudio</b> (voz clara, más graves, películas…) y debajo, <b>tus ajustes guardados</b>. ◀ ▶ cambian entre ellos.',
  'tutorial.s.saveBtn.title': 'Guardar',
  'tutorial.s.saveBtn.body': '¿Te gusta cómo suena? Pulsa <b>Guardar</b>, ponle nombre y queda en tu cuenta.',
  'tutorial.s.bypass.title': 'Compara con Bypass',
  'tutorial.s.bypass.body': '<b>BYPASS</b> apaga todos los efectos de golpe (al mismo volumen) para que oigas la diferencia.',
  'tutorial.s.recalibrate.title': 'El test de audición',
  'tutorial.s.recalibrate.body': 'Un test corto de tus parlantes o audífonos. DragonAudio corrige lo que les falta.',
  'tutorial.s.device.title': 'Tu dispositivo',
  'tutorial.s.device.body': 'Cada test queda como <b>perfil de dispositivo</b>. Elígelo aquí cuando cambies de audífonos o parlantes.',
  'tutorial.s.theme.title': 'Claro u oscuro',
  'tutorial.s.theme.body': 'Este interruptor cambia entre modo <b>claro</b> y <b>oscuro</b>.',
  'tutorial.s.lang.title': 'Idioma',
  'tutorial.s.lang.body': 'Cambia entre <b>inglés</b> y <b>español</b> sin cortar lo que suena.',
  'tutorial.s.mode.title': 'Ligero o Dragón',
  'tutorial.s.mode.body': '<b>Dragón</b> trae fondo animado y visualizador. <b>Ligero</b> apaga todos los adornos y deja la CPU para el sonido: ideal para equipos modestos.',
  'tutorial.s.spectrum.title': 'El visualizador',
  'tutorial.s.spectrum.body': 'Mira tu sonido en vivo: graves a la izquierda, agudos a la derecha. Cambia el estilo o <b>congélalo</b> para mirarlo con calma.',
};

const tutorial = { en, es };
export default tutorial;
